import React from 'react';
import { OrganizationalRoleType } from '../../constants/OrganizationalRoleType';
import { RoundedButton, ButtonColor, ButtonCorner } from '../Buttons/RoundedButton';
import Button from '../UIButton/UIButton';

const toDateString = (s) => {
    const d = new Date(s);
    if (isNaN(d.getTime())) {
        return ''; // Return an empty string if the input is invalid
    }
    const dateFormatted = new Intl.DateTimeFormat("en-US", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit"
    }).format(d);
    return dateFormatted;
};


const UserRoleCard = ({ role, openModal, updateModalData }) => {
    const isCustomRole = role.organizationalRoleType === OrganizationalRoleType.Custom;

    const editClickHandler = () => {
        updateModalData({
            roleName: `${role.roleName} ${!isCustomRole ? "(Default)" : ""}`,
            roleType: role.organizationalRoleType,
            roleId: role.organizationalRoleId
        })
        openModal();
    }
    
    return (
        <tr>
            <td>{role.roleName}{!isCustomRole ? " (Default)" : ""}</td>
            <td className="text-end">{toDateString(role.lastUpdated)}</td>
            <td className="text-end">
                <Button
                    variant="primary"
                    size="small"
                    onClick={editClickHandler}>
                    Edit
                </Button>
                {!isCustomRole && <span className="ml-2"><i className="fa fa-lock" aria-hidden="true"></i></span>}
            </td>
        </tr>
    );
};

export default UserRoleCard;
